/**
 * Helper utility to construct a valid browser URL for static images and media.
 * Strips `/api` or `/api/v1` from backend environment URLs so `/static/...` assets
 * are served directly by Nginx (or FastAPI static files).
 */
export function getImageUrl(path) {
  if (!path) return '';
  if (
    path.startsWith('http://') ||
    path.startsWith('https://') ||
    path.startsWith('data:') ||
    path.startsWith('blob:')
  ) {
    return path;
  }

  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const rawApiUrl = import.meta.env.VITE_API_URL || import.meta.env.VITE_API_BASE_URL || '';

  let baseHost = '';
  if (rawApiUrl) {
    baseHost = rawApiUrl.replace(/\/api(\/v1)?\/?$/, '');
  }

  const separator = cleanPath.includes('?') ? '&' : '?';
  return `${baseHost}${cleanPath}${separator}v=restore`;
}
